import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/plancomptable`;
const token = localStorage.getItem("token");

/// GET : tous les plancomptables
export const getAllPlanComptables = async () => {
  try {
    const response = await axios.get(`${apiUrl}/all`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des plancomptables", error);
    throw error;
  }
};
